"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setSpecies = exports.setSessionStartTime = exports.setPromo = exports.setPetName = exports.setPartner = exports.setIsSessionValid = exports.setBreed = exports.setApplicationQuoteObjectId = exports.setActiveBrand = exports.resetSession = exports.resetSearchParams = exports.resetActiveBrand = exports["default"] = exports.appSlice = void 0;
var _toolkit = require("@reduxjs/toolkit");
var initialState = {
  activeBrand: {
    brandKey: '',
    apiKey: '',
    clientId: ''
  },
  session: {
    sessionStartTime: null,
    isSessionValid: true
  },
  searchParams: {
    promo: undefined,
    species: undefined,
    petName: undefined,
    breed: undefined,
    applicationQuoteObjectId: undefined,
    partner: undefined
  }
};
var appSlice = exports.appSlice = (0, _toolkit.createSlice)({
  name: 'app',
  initialState: initialState,
  reducers: {
    setActiveBrand: function setActiveBrand(state, action) {
      state.activeBrand = action.payload;
    },
    setSessionStartTime: function setSessionStartTime(state, action) {
      state.session.sessionStartTime = action.payload;
    },
    setIsSessionValid: function setIsSessionValid(state, action) {
      state.session.isSessionValid = action.payload;
    },
    setPromo: function setPromo(state, action) {
      state.searchParams.promo = action.payload;
    },
    setSpecies: function setSpecies(state, action) {
      state.searchParams.species = action.payload;
    },
    setPetName: function setPetName(state, action) {
      state.searchParams.petName = action.payload;
    },
    setBreed: function setBreed(state, action) {
      state.searchParams.breed = action.payload;
    },
    setApplicationQuoteObjectId: function setApplicationQuoteObjectId(state, action) {
      state.searchParams.applicationQuoteObjectId = action.payload;
    },
    setPartner: function setPartner(state, action) {
      var _action$payload, _action$payload$brand;
      var partner = (_action$payload = action.payload) === null || _action$payload === void 0 || (_action$payload = _action$payload.partner) === null || _action$payload === void 0 ? void 0 : _action$payload.toLowerCase();
      if ((_action$payload$brand = action.payload.brandConfig) !== null && _action$payload$brand !== void 0 && (_action$payload$brand = _action$payload$brand.theme) !== null && _action$payload$brand !== void 0 && (_action$payload$brand = _action$payload$brand.brand) !== null && _action$payload$brand !== void 0 && (_action$payload$brand = _action$payload$brand.brokers) !== null && _action$payload$brand !== void 0 && _action$payload$brand[partner]) {
        state.searchParams.partner = partner;
      }
    },
    resetActiveBrand: function resetActiveBrand(state) {
      state.activeBrand = initialState.activeBrand;
    },
    resetSession: function resetSession(state) {
      state.session = initialState.session;
    },
    resetSearchParams: function resetSearchParams(state) {
      state.searchParams = initialState.searchParams;
    }
  }
});
var _appSlice$actions = appSlice.actions,
  setActiveBrand = exports.setActiveBrand = _appSlice$actions.setActiveBrand,
  resetActiveBrand = exports.resetActiveBrand = _appSlice$actions.resetActiveBrand,
  setSessionStartTime = exports.setSessionStartTime = _appSlice$actions.setSessionStartTime,
  setIsSessionValid = exports.setIsSessionValid = _appSlice$actions.setIsSessionValid,
  resetSession = exports.resetSession = _appSlice$actions.resetSession,
  setPromo = exports.setPromo = _appSlice$actions.setPromo,
  setSpecies = exports.setSpecies = _appSlice$actions.setSpecies,
  setPetName = exports.setPetName = _appSlice$actions.setPetName,
  setBreed = exports.setBreed = _appSlice$actions.setBreed,
  setApplicationQuoteObjectId = exports.setApplicationQuoteObjectId = _appSlice$actions.setApplicationQuoteObjectId,
  setPartner = exports.setPartner = _appSlice$actions.setPartner,
  resetSearchParams = exports.resetSearchParams = _appSlice$actions.resetSearchParams;
var _default = exports["default"] = appSlice.reducer;